import { RefObject, useEffect, useState } from "react";

type IOnEnterViewportProps = IntersectionObserverInit & {
    ref: RefObject<Element>;
    freezeOnceVisible?: boolean;
};

type IOnEnterViewport = {
    isEnter: boolean;
};

export const useOnEnterViewport = (props: IOnEnterViewportProps) => {
    const {
        ref,
        root,
        rootMargin,
        threshold,
        freezeOnceVisible,
    } = props;

    const [res, setRes] = useState<IOnEnterViewport>({
        isEnter: false,
    });

    const frozen = res?.isEnter && freezeOnceVisible;

    useEffect(() => {
        const callback = (entries: IntersectionObserverEntry[]) => {
            const [entry] = entries;

            setRes({
                isEnter: entry.isIntersecting,
            });
        };
        const observer = new IntersectionObserver(callback, {
            root,
            rootMargin,
            threshold,
        });
        if (ref?.current && !frozen) {
            observer.observe(ref.current);
        }

        return () => observer.disconnect();
    }, [ref, root, rootMargin, threshold, frozen]);

    return {
        isEnterViewport: res.isEnter,
    };
};
